import type { RouteRecordRaw } from 'vue-router';

// Import all route modules
import coreRoutes from './core';
import client from './client';
import administration from './administration';
import services from './services';
import laboratory from './laboratory';
import crm from './crm';

// Combine all routes
const routes: RouteRecordRaw[] = [...coreRoutes, client, administration, services, laboratory, crm];

export default routes;
